"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeRestObjects = exports.BaseIkeObject = void 0;
var annotation_summary_object_1 = require("./annotation.summary.object");
var calibration_object_1 = require("./calibration.object");
var capture_object_1 = require("./capture.object");
var collection_history_object_1 = require("./collection.history.object");
var collection_object_1 = require("./collection.object");
var collection_summary_object_1 = require("./collection.summary.object");
var department_object_1 = require("./department.object");
var device_objects_1 = require("./device.objects");
var form_object_1 = require("./form.object");
var form_summary_object_1 = require("./form.summary.object");
var tag_object_1 = require("./tag.object");
var tag_summary_object_1 = require("./tag.summary.object");
var token_object_1 = require("./token.object");
var user_profile_object_1 = require("./user.profile.object");
var base_1 = require("./base");
Object.defineProperty(exports, "BaseIkeObject", { enumerable: true, get: function () { return base_1.IkeRestObject; } });
exports.IkeRestObjects = {
    AnnotationSummary: new annotation_summary_object_1.IkeObjectAnnotationSummary(),
    Calibration: new calibration_object_1.IkeObjectCalibration(),
    Capture: new capture_object_1.IkeObjectCapture(),
    Collection: new collection_object_1.IkeObjectCollection(),
    CollectionHistory: new collection_history_object_1.IkeObjectCollectionHistory(),
    CollectionSummary: new collection_summary_object_1.IkeObjectCollectionSummary(),
    Department: new department_object_1.IkeObjectDepartment(),
    Device: new device_objects_1.IkeObjectDevice(),
    Form: new form_object_1.IkeObjectForm(),
    FormSummary: new form_summary_object_1.IkeObjectFormSummary(),
    Tag: new tag_object_1.IkeObjectTag(),
    TagSummary: new tag_summary_object_1.IkeObjectTagSummary(),
    Token: new token_object_1.IkeObjectToken(),
    UserProfile: new user_profile_object_1.IkeObjectUserProfile()
};
//# sourceMappingURL=object.js.map